import React from "react";
import { HeaderContainer } from "./style";
import Profile from "../profile";
import Notifications from "../notifications";
import Setting from "../setting";
import Help from "./components/help";
import Logo from "../../../components/logo";

export const Header = props => {
  const { RightComponent, LeftComponent, disable, borderless } = props;

  return (
    <HeaderContainer borderless={borderless}>
      <div className="right-side">
        {!disable &&
          (RightComponent ? (
            <RightComponent />
          ) : (
            <React.Fragment>
              <i
                className="right-side-icon icon mapsa-menu"
                title="منو"
                onClick={() => props.sidebarToggleHandler()}
              />
              <Logo/>
            </React.Fragment>
          ))}
      </div>
      <div className="left-side">
        {LeftComponent ? (
          <LeftComponent />
        ) : (
          <React.Fragment>
            <Help/>
            <Notifications/>
            <Setting/>
            <div className="separator" />
            <Profile/>
          </React.Fragment>
        )}
      </div>
      {props.children}
    </HeaderContainer>
  );
};
